<template>
  <div>
    <span v-if="showColor" :class="{[employee.category_display_color + '--text']:true}" class="text--darken-2 employee-name">
      <template v-if="link">
        <router-link :to="{ name: 'employeeDetail', params: { employeeId: idToUse }}">
          {{ nameToShow }}
        </router-link>
      </template>
      <template v-else>
        {{ nameToShow }}
      </template>
    </span>
    <span v-else class="text--darken-2 employee-name">
      <template v-if="link">
        <router-link :to="{ name: 'employeeDetail', params: { employeeId: idToUse }}">
          {{ nameToShow }}
        </router-link>
      </template>
      <template v-else>
        {{ nameToShow }}
      </template>
    </span>
    <span v-if="employee && employee.deactivated" class="subtle">
      (DEACTIVATED)
    </span>
  </div>
</template>

<script>
export default {
  name: 'EmployeeName',
  props: {
    'employee': Object,
    'showColor': Boolean,
    'name': String,
    'employeeId': Number,
    'link': Boolean,
  },
  computed: {
    nameToShow: function () {
      if (this.employee && this.employee.display_name) {
        return this.employee.display_name
      } else if (this.name) {
        return this.name
      } else {
        return "Cannot find name"
      }
    },
    idToUse: function () {
      if (this.employee && this.employee.id) {
        return this.employee.id
      } else if (this.employeeId) {
        return this.employeeId
      } else {
        return 0
      }
    }
  },
}
</script>

<style scoped>
.employee-name a {
  color: inherit;
}
</style>
